import * as React from 'react';


const Logo = () => {

    return (
        <a className='logoContainer' href='/'>
            <p className='logo stick' > Znana < br />
                Makijażystka</p >
        </a >


    );
};

export default Logo;

